export { renderDrawerBody_unstable as renderDrawerBody } from '@fluentui/react-drawer';
